export const globalFunctions = {
    parseNumber: (number, decimals = 1) => {
        const formatter = new Intl.NumberFormat('de-DE', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
        });

        return formatter.format(parseFloat(number))
    }
}